import Layout from "../../layouts/layout"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Loading from "../../components/loading/loading"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { deleteSingleUser, getAllUsers } from "../../api/users"
import { ReactComponent as Filter } from "../../assets/icons/shapes/filter.svg"
import { ReactComponent as View } from "../../assets/icons/generals/view.svg"
import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { toast } from "react-toastify"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"

const Users = () => {

    const naviagte = useNavigate()
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)
    const [activeTab, setActiveTab] = useState(0)




    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.name + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }

    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, refetch } = Query(
        ['getAllUsers', searchKeyword, page],
        () => getAllUsers(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );

    const { mutate: deleteMutate } = Mutate(
        "deleteUsers",
        deleteSingleUser,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    )

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout title={"کاربران"} buttonTitle={"کاربر جدید"} buttonLink={"/admin/users/create"} >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        {/* <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>جدید ترین</button>
                        <button onClick={() => setActiveTab(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>قدیمی ترین</button> */}
                    </div>
                    <div className="flex wsm:mb-4">
                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder=' جستوجو کاربران ...' />
                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div>
                </div>
                <table className="table-auto transition-all" >
                    <thead className="!py-2">
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">نام و نام خانوادگی</th>
                            <th className="py-3">شماره تلفن</th>
                            <th className="py-3">ایمیل</th>
                            {/* <th className="py-3">نقش</th> */}
                            <th className="py-3">عملیات</th>
                        </tr>
                    </thead>
                    {
                        !isLoading &&
                        <tbody>
                            {
                                data?.data?.map(el => (
                                    <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                        <td className="text-center py-5" >{el.id}</td>
                                        <td className="text-center py-5" > {el.name} {el.lastname}</td>
                                        <td className="text-center py-5" > {el.phone}</td>
                                        <td className="text-center py-5" > {el.email}</td>
                                        {/* <td className="text-center py-5 " >
                                                    <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                        {el?.roles.length ? "سوپر ادمین" : "کاربر"}
                                                    </div>
                                                </td> */}
                                        <td className="text-center py-5" >
                                            <div className="flex justify-evenly items-center">
                                                <div className=" cursor-pointer" onClick={() => naviagte("/admin/users/" + el.id)}><View width={"20"} height="20" /></div>
                                                <div className="cursor-pointer" onClick={() => naviagte('/admin/users/edit/' + el.id)}><Edit width={"20"} height="20" /></div>
                                                <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "کاربر") }}><Delete width={"20"} height="20" /></div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    }
                </table>
                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
    )
}

export default Users